import { Switch } from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";
import {
  AdminEditUserMutation,
  AdminEditUserMutationVariables,
  UserFragment,
} from "gql/graphql";
import { useMutation } from "@apollo/client";
import ADMIN_EDIT_USER_MUTATION from "../_networking/admin-edit-user";
import useUserPreference from "modules/hooks/use-user-preference";

interface IProps {
  user: UserFragment;
}

const AdminEditUserSms = ({ user }: IProps) => {
  const isSmsDisabled = useMemo(() => !user?.phone, [user?.phone]);
  const { booleanValue: isSms } = useUserPreference({
    name: "SMS",
    userId: user.id,
  });

  const [adminEditUserMutationAPI] = useMutation<
    AdminEditUserMutation,
    AdminEditUserMutationVariables
  >(ADMIN_EDIT_USER_MUTATION);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      adminEditUserMutationAPI({
        variables: {
          id: user.id,
          input: {
            userPreferenceList: [
              {
                name: "SMS",
                value: e.target.checked === true ? "true" : "false",
              },
            ],
          },
        },
      });
    },
    [adminEditUserMutationAPI, user],
  );

  return (
    <Switch
      size="sm"
      defaultChecked={isSms}
      onChange={onChange}
      isDisabled={isSmsDisabled}
    />
  );
};

export default memo(AdminEditUserSms);
